<template lang="pug">
  #app(:class="$store.getters.getBrandedClass")
    TheHeader
    main#the-main.container: .row
      .col.col-left: .stepper
        .stepper-inner
          TheStepperTop
          RouterView
          TheStepperBottom
      .col.col-right(:class="welcomeClass")
        TheWelcome(@welcome-click="welcomeHandler")
    TheFooter
    .mount-point(ref="mountPoint")
</template>

<script>
import svg4everybody from 'svg4everybody'
import TheHeader from '@/layouts/TheHeader'
import TheFooter from '@/layouts/TheFooter'
import TheStepperTop from '@/layouts/TheStepperTop'
import TheStepperBottom from '@/layouts/TheStepperBottom'
import TheWelcome from '@/layouts/TheWelcome'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  // Components ----------------------------------------------------------------
  components: {
    TheHeader,
    TheFooter,
    TheStepperTop,
    TheStepperBottom,
    TheWelcome
  },
  // Created ------------------------------------------------------------ [Hook]
  created () {
    if (this.hasParentFrame) {
      window.addEventListener('message', this.receiveMessage)
    }
  },
  // Mounted ------------------------------------------------------------ [Hook]
  mounted () {
    svg4everybody()
  },
  // Before destroy ----------------------------------------------------- [Hook]
  beforeDestroy () {
    window.removeEventListener('message', this.receiveMessage)
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      welcome: false,
      sectionHeading: 'Получите портфель ценных бумаг за пару секунд'
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Security SM
    ...mapGetters('moduleSecurity', ['hasParentFrame']),
    // Welcome btn class
    welcomeClass () {
      return this.welcome ? 'hide' : ''
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', ['receiveMessage']),
    // Welcome handler
    welcomeHandler () {
      this.welcome = true
    }
  }
}
</script>

<style lang="scss" src="@/assets/scss/main.scss"></style>
